import { Router } from "express";

import { programAppealController } from "../controllers/program-appeal-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import { uploadMiddleware } from "../middleware/upload-middleware";

const router = Router();
const generalRateLimit = createRateLimit.general();

router.post(
  "/student/program-appeals",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  uploadMiddleware.array("documents", 10),
  (req, res) => programAppealController.createProgramAppeal(req, res),
);

router.get(
  "/student/program-appeals/:id",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => programAppealController.getStudentProgramAppeal(req, res),
);

router.get(
  "/school/program-appeals",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => programAppealController.getSchoolProgramAppeals(req, res),
);

router.put(
  "/school/program-appeals/:id/resolve",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => programAppealController.resolveProgramAppeal(req, res),
);

export default router;
